module.exports = __webpack_public_path__ + "img/payment-failed.da9cdd2c.svg";